import { useMemo } from "react";

import useDevMode from "../../utils/devmode";
import useApi from "../apiConfig";
import QueryClient from "./queryClient";

const useQueryClient = (): QueryClient => {
  const devMode = useDevMode();
  const api = useApi();
  return useMemo(() => new QueryClient(devMode, api), [devMode, api]);
};

export default useQueryClient;
